import { useTranslations as nextUseTranslations } from 'next-intl';
import { Fragment } from 'react';

export function useTranslations(scope?: string) {
  const t = nextUseTranslations(scope);

  const tbr = (key: string) => {
    const str = t(key);
    return str.split('\n').map((line, i) => (
      <Fragment key={i}>
        {line}
        {i < str.split('\n').length - 1 && <br />}
      </Fragment>
    ));
  };

  return { t, tbr };
}
